import { VStack } from '@chakra-ui/react';

import { For } from 'shared';

import { GoalExtended } from 'features/goal/config/types';

import { GoalPrioritizeModalListItem } from './ListItem';

type GoalsListProps = {
  goals: GoalExtended[];
  onGoalToggle: (goalId: string) => void;
};

export const GoalPrioritizeModalList = ({
  goals,
  onGoalToggle,
}: GoalsListProps) => (
  <VStack alignItems="flex-start" gap="var(--spacing02)">
    <For each={goals}>
      {({ goalId, title, imageUrl, dimensions, isDisabled, isChecked }) => (
        <GoalPrioritizeModalListItem
          key={goalId}
          goalId={goalId}
          title={title}
          imageUrl={imageUrl}
          dimensions={dimensions}
          isDisabled={isDisabled}
          isChecked={isChecked}
          onGoalToggle={onGoalToggle}
        />
      )}
    </For>
  </VStack>
);
